import React from 'react';
export const QueIncluye: React.FC = () => {
  const libros = [{
    name: 'Princesas',
    emoji: '👑',
    color: 'bg-pink-100',
    text: 'text-pink-900'
  }, {
    name: 'Rey León',
    emoji: '🦁',
    color: 'bg-amber-100',
    text: 'text-amber-900'
  }, {
    name: 'Cars',
    emoji: '🚗',
    color: 'bg-red-100',
    text: 'text-red-900'
  }, {
    name: 'La Sirenita',
    emoji: '🧜‍♀️',
    color: 'bg-teal-100',
    text: 'text-teal-900'
  }, {
    name: 'Frozen',
    emoji: '❄️',
    color: 'bg-sky-100',
    text: 'text-sky-900'
  }, {
    name: 'Mickey Mouse',
    emoji: '🐭',
    color: 'bg-red-100',
    text: 'text-red-900'
  }, {
    name: 'Robin Hood',
    emoji: '🦊',
    color: 'bg-orange-100',
    text: 'text-orange-900'
  }, {
    name: 'Stitch',
    emoji: '🐉',
    color: 'bg-blue-100',
    text: 'text-blue-900'
  }, {
    name: 'Toy Story',
    emoji: '🤠',
    color: 'bg-yellow-100',
    text: 'text-yellow-900'
  }, {
    name: 'Moana',
    emoji: '🌺',
    color: 'bg-emerald-100',
    text: 'text-emerald-900'
  }, {
    name: 'Hércules',
    emoji: '⚡',
    color: 'bg-orange-100',
    text: 'text-orange-900'
  }, {
    name: 'Peter Pan',
    emoji: '🧚',
    color: 'bg-green-100',
    text: 'text-green-900'
  }, {
    name: 'Villanos',
    emoji: '😈',
    color: 'bg-purple-100',
    text: 'text-purple-900'
  }, {
    name: 'Monsters Inc.',
    emoji: '👾',
    color: 'bg-lime-100',
    text: 'text-lime-900'
  }, {
    name: 'Donald',
    emoji: '🦆',
    color: 'bg-blue-100',
    text: 'text-blue-900'
  }, {
    name: 'Y muchos más...',
    emoji: '🏰',
    color: 'bg-white/10',
    text: 'text-white'
  }];
  return <section className="py-8 px-4 bg-violet text-cream relative overflow-hidden" data-id="element-173">
      <div className="max-w-4xl mx-auto relative z-10" data-id="element-174">
        <div className="text-center mb-2" data-id="element-175">
          <span className="inline-block bg-yellow text-violet font-rounded font-bold uppercase tracking-widest text-xs px-3 py-1.5 rounded-full mb-3" data-id="element-176">
            La colección completa
          </span>
        </div>
        <h2 className="font-rounded font-bold text-[2rem] sm:text-4xl text-cream text-center leading-tight mb-2" data-id="element-177">
          Todo lo que <span className="text-yellow" data-id="element-178">desbloqueás hoy</span>
        </h2>
        <p className="text-center text-cream/80 mb-8 text-base font-semibold" data-id="element-179">
          Una biblioteca completa con los personajes favoritos de tus hijos.
        </p>

        <div className="mb-6" data-id="element-180">
          <img src="https://cdn.magicpatterns.com/uploads/d4RRdDi26Um4PeNDBwU8ao/colecion_completa.png" alt="Biblioteca completa de coloreables Disney" className="w-full h-auto drop-shadow-2xl" data-id="element-181" />
        </div>

        <p className="text-center text-yellow font-rounded font-bold text-lg sm:text-xl mb-6 leading-snug" data-id="element-182">
          Sus personajes favoritos, todos en un mismo lugar.
        </p>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-2 mb-6" data-id="element-183">
          {libros.map((libro, idx) => <div key={idx} className={`${libro.color} ${libro.text} rounded-xl p-3 flex items-center gap-2 shadow-md border-l-4 border-gold`} data-id="element-184">
              <span className="text-2xl flex-shrink-0" data-id="element-185">{libro.emoji}</span>
              <span className="font-rounded font-bold text-xs sm:text-sm leading-tight" data-id="element-186">
                {libro.name}
              </span>
            </div>)}
        </div>

        <div className="text-center" data-id="element-187">
          <span className="inline-block bg-yellow text-violet font-rounded font-bold uppercase tracking-wide text-sm px-5 py-2.5 rounded-full shadow-lg" data-id="element-188">
            ✨ Más de 50 libros incluidos
          </span>
        </div>
      </div>
    </section>;
};